import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { serverUrl, getAuthHeader } from ".";
import axios from "axios";

export const useUnreadInbox = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ["unreadInbox"],
    queryFn: async () => {
      const response = await axios.get(
        `${serverUrl}/notice/inbox/unread`,
        getAuthHeader()
      );
      return response.data;
    },
    enabled: enabled,
  });
};

export const usePatchStudent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const response = await axios.patch(
        `${serverUrl}/student/`,
        data,
        getAuthHeader()
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["student"] });
    },
  });
};

export const useStudentList = ({
  filter,
}: {
  filter?: Record<string, string>;
}) => {
  return useQuery({
    queryKey: ["studentList", filter],
    queryFn: async () => {
      const response = await axios.get(
        `${serverUrl}/student/list?${new URLSearchParams(filter).toString()}`,
        getAuthHeader()
      );
      return response.data;
    },
    enabled: false,
  });
};

export const useStudentDocs = ({
  filter,
  enabled,
}: {
  filter: Record<string, string>;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ["ownDocs", filter],
    queryFn: async () => {
      const response = await axios.get(
        `${serverUrl}/student/docs?${new URLSearchParams(filter).toString()}`,
        getAuthHeader()
      );
      return response.data;
    },
    enabled,
  });
};

export const useStudent = () => {
  return useQuery({
    queryKey: ["student"],
    queryFn: async () => {
      const response = await axios.get(`${serverUrl}/student`, getAuthHeader());
      return response.data;
    },
  });
};
